"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoRecordsContent = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DataGrid = require("../DataGrid.styles");

var _helperFunctions = require("../../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoRecordsContent = (0, _styledComponents.default)(_DataGrid.TableArea).withConfig({
  displayName: "NoRecordsstyles__NoRecordsContent",
  componentId: "k294d2-0"
})(["display:flex;padding:", " 0;justify-content:center;"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
});
exports.NoRecordsContent = NoRecordsContent;